/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 17:46:18
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-02 17:52:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/Components/Search/index.tsx
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Query from 'src/constrains/Query1';
import css from './css.module.less';
import { useAfterDidMountEffect } from 'src/tools/customHooks';

const Search = (props) => {
  const { onSearchChange, getSearch, onSearchHasChange, onSearchTagClose } =
    props;
  const _d = useDispatch();
  const search = useSelector(getSearch());

  useAfterDidMountEffect(() => {
    if (onSearchHasChange) onSearchHasChange(search);
  }, [search]);

  const handleOnSearchChange = (e) => {
    _d(onSearchChange(e));
  };

  const handleOnSearchTagClose = (e) => {
    _d(onSearchTagClose({ item: e }));
  };

  return (
    <div className={css.container}>
      <Query
        onTagClose={handleOnSearchTagClose}
        data={{ search }}
        onSearchChange={handleOnSearchChange}
      />
    </div>
  );
};
export default Search;
